import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-person-adult.svg"

const IconCategoryPerson = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryPerson.displayName = "IconCategoryPerson"
export default IconCategoryPerson
